<template>
    <form class="o-form" action="#" method="post" @submit.prevent="submit">
        <div class="c-home-forms__forms__inner c-home-forms-echange">
            <div class="c-home-forms-echange__item c-home-forms-inner__annee">
                <div class="o-form-group__item">
                    <label class="o-label sr-only" for="annee">Année</label>
                    <div class="o-select__wrap">
                        <select class="o-select" name="Année" required v-model="year">
                            <option disabled selected value="">Année</option>
                            <option v-for="y in years">{{ y }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="c-home-forms-echange__item c-home-forms-inner__marques">
                <div class="o-form-group__item">
                    <label class="o-label sr-only" for="marques">Marques</label>
                    <div class="o-select__wrap">
                        <select class="o-select" required id="marques" v-model="make" name="Marque">
                            <option disabled selected value="">Marque</option>
                            <option v-for="m in makes">{{ m }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="c-home-forms-echange__item c-home-forms-inner__modeles">
                <div class="o-form-group__item">
                    <label class="o-label sr-only" for="inventaire">Modèles</label>
                    <div class="o-select__wrap">
                        <select class="o-select" id="Modeles" v-model="model" name="Modele">
                            <option disabled selected value="">Modèle</option>
                            <option v-for="m in models">{{ m }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="c-home-forms-echange__item c-home-forms-inner__version">
                <div class="o-form-group__item">
                    <label class="o-label sr-only" for="version">Version</label>
                    <div class="o-select__wrap">
                        <select class="o-select" id="version" v-model="trim" name="Version">
                            <option disabled selected value="">Version</option>
                            <option v-for="m in trims">{{ m }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="c-home-forms-echange__item c-home-forms-inner__km">
                <div class="o-form-group__item">
                    <label class="o-label sr-only" for="km">Kilométage</label>
                    <div class="o-select__wrap -no-arrow">
                        <input type="text" v-model="km" class="o-select" required id="km" name="Kilométrage" placeholder="Kilométrage">
                    </div>
                </div>
            </div>
        </div>
        <div class="-alt">
            <div class="o-form-wrapper o-form-financement">
                <div class="o-form-group">
                    <div class="o-form-group__column">
                        <div class="o-form-group__item">
                            <label class="o-label sr-only" for="nom">Nom</label>
                            <input v-model="nom" class="o-input" type="text" id="nom" name="Nom" placeholder="Nom" required>
                        </div>
                    </div>
                    <div class="o-form-group__column">
                        <div class="o-form-group__item">
                            <label class="o-label sr-only" for="courriel">Courriel</label>
                            <input v-model="courriel" class="o-input" type="email" id="courriel" name="Courriel" placeholder="Courriel" required>
                        </div>
                    </div>

                    <div class="o-form-group__column">
                        <div class="o-form-group__item">
                            <label class="o-label sr-only" for="telephone">Téléphone</label>
                            <input v-model="telephone" class="o-input" type="text" id="telephone" name="Téléphone" placeholder="Téléphone">
                        </div>
                    </div>

                </div>
                <div class="o-form__button">
                    <input type="hidden" name="Concessionnaire" :value="concession">
                    <input type="hidden" name="formulaire" value="Évaluation">
                    <button class="o-button -lg js-btn-evaluate" type="submit" data-cta-target=".js-overlay-confirmation">
                        <span class="o-button__text">Soumettre</span>
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>
<script>


export default {
    name: 'Controls',
    props: {
        concession: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            year: '',
            make: '',
            model: '',
            trim: '',
            km: '',
            nom: '',
            courriel: '',
            telephone: '',
            store: []
        }
    },
    computed: {
        years() {
            // Return all years from 2011 to next year
            let years = [];
            for (let i = new Date().getFullYear() + 1; i >= 2011; i--) {
                years.push(i);
            }
            return years;
        },
        makes() {
            let makes = this.store.map(item => item.name);
            if (!makes.includes(this.make)) {
                this.make = '';
            }
            return makes;
        },
        models() {
            let models = this.make ? this.store.find(item => item.name === this.make).models.map(item => item.name) : [];
            if (!models.includes(this.model)) {
                this.model = '';
            }
            return models;
        },
        trims() {
            let trims = this.model ? this.store.find(item => item.name === this.make).models.find(item => item.name === this.model).trims.map(item => item.name) : [];
            if (!trims.includes(this.trim)) {
                this.trim = '';
            }
            return trims;
        }
        
    },
    watch: {
        year() {

            fetch('https://cardb.stereodev.ca/'+this.year+'.json')
                .then(response => response.json())
                .then(data => {
                    this.store = data;

                    if (!this.makes.includes(this.make)) {
                        this.make = '';
                    }

                });
        }        
        
    },
    methods: {
        submit(e) {
            
            const fd = new FormData(e.currentTarget);
            var additions = {
                "Page actuelle": location.href,
                "Page précédente": document.referrer,
                "lpdgform": "1"
            }
            for (var key in additions) {
                fd.append(key, additions[key]);
            }
            fetch('/', {
                method: "POST",
                credentials: "same-origin",
                body: fd,
            });
            document.querySelector('body').classList.add('overlay-active');
            document.querySelectorAll('.c-overlay-cta-form').forEach((ele) => {ele.style.display = 'none'});
            document.querySelector('.js-overlay-cta').classList.add('is-active');
            document.querySelector('.js-overlay-confirmation-evaluate').style.display = 'block';
        }
    }
}
</script>
